import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, WhatsappTemplateResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof WhatsappTemplateResponseDataSchema>>
type OnSuccessFn = (data: Response["data"]) => void

const getWhatsappTemplateQueryKey = (id: string) => ["campaignsWhatsappTemplates", id]

type Props = {
  id: string
  onSuccess?: OnSuccessFn
  disabled?: boolean
}

export const whatsappTemplateQuery = ({ id, onSuccess, disabled }: Props) => {
  return queryOptions({
    queryKey: getWhatsappTemplateQueryKey(id),
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/integrations/whatsapp/templates/${id}`)
      onSuccess?.(data.data)
      return data.data
    },
    enabled: !disabled,
  })
}
